import CustomComponent from './CustomComponent';

const constructComponents = compSettings => {
  const comps = compSettings.components;
  const components = {
    top: false,
    bottom: false,
  };
  const defaultCcProps = {...compSettings.default};

  if (comps) {
    comps.forEach(comp => {
      const settings = comp.settings;
      let component = comp.comp;
      let props = {...defaultCcProps};
      if (settings && settings.passController) {
        component = CustomComponent;
        props.dt_cust_comp = comp.comp;
        props.controller = compSettings.controller;
      }
      props = {...props, ...comp.props, params: comp.params || false};
      const result = {component: component, props: props};
      components[comp.location] = result;
    })
  }

  return components;
}

export default constructComponents;
